import { useState } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from 'sonner';
import { User } from '@supabase/supabase-js';

export const useFeedbackPopup = (user: User | null) => {
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

  const submitFeedback = async (
    feedback: string, 
    canContact: boolean,
    rating: string
  ) => {
    if (!user) {
      toast.error("Please log in to submit feedback");
      return false;
    }

    try {
      console.log("Submitting feedback:", { feedback, canContact, rating });
      
      // Insert feedback with all required fields
      const { error: feedbackError } = await supabase
        .from('user_feedback')
        .insert({
          user_id: user.id,
          feedback,
          can_contact: canContact,
          email: user.email,
          rating,
          status: 'unread', // Add default status
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        });

      if (feedbackError) {
        console.error("Feedback submission error:", feedbackError);
        throw feedbackError;
      }

      // Show success message
      toast.success("Thank you for your feedback!");
      console.log("Feedback submitted successfully");
      return true;
    } catch (error) {
      console.error("Error submitting feedback:", error);
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error("Failed to submit feedback. Please try again.");
      }
      return false;
    }
  };

  return { 
    showFeedbackPopup, 
    setShowFeedbackPopup, 
    submitFeedback 
  };
};
